import {Store} from 'vuex'
import {parametrage} from '@/shared/parametrage'
import {StatutsAcdemat} from '@/shared/dossier/enum-statuts-acdemat'
import StatutDossier from '@/shared/dossier/statut-dossier'
import _ from 'lodash'

export default class SectionsService {
  constructor(private store: Store<any>) {
    this.store = store
  }

  parametrageSections = [
    {
      nom: 'suivi',
      numeroOrdre: 1,
      affichagePour: [parametrage.originesDossier.SAD, parametrage.originesDossier.SYNTHURBA],
      typesExclus: null
    },
    {
      nom: 'depot',
      numeroOrdre: 2,
      affichagePour: [parametrage.originesDossier.ACDEMAT],
      statutMinimun: StatutsAcdemat.DEPOSE
    },
    {
      nom: 'instruction',
      numeroOrdre: 3,
      affichagePour: [parametrage.originesDossier.ACDEMAT],
      statutMinimun: StatutsAcdemat.EN_INSTRUCTION
    },
    {
      nom: 'synthese-decision',
      numeroOrdre: 4,
      affichagePour: [parametrage.originesDossier.ACDEMAT],
      statutMinimun: StatutsAcdemat.EN_SYNTHESE
    },
    {
      nom: 'prolongation',
      numeroOrdre: 5,
      affichagePour: [parametrage.originesDossier.ACDEMAT]
    },
    {
      nom: 'chantier',
      numeroOrdre: 6,
      affichagePour: [parametrage.originesDossier.ACDEMAT],
      statutMinimun: StatutsAcdemat.SUIVI_CHANTIER
    },
    {
      nom: 'mise-en-service',
      numeroOrdre: 7,
      affichagePour: [parametrage.originesDossier.ACDEMAT],
      statutMinimun: StatutsAcdemat.MISE_EN_SERVICE
    },
    {
      nom: 'fin',
      numeroOrdre: 8,
      affichagePour: [parametrage.originesDossier.ACDEMAT],
      statutMinimun: StatutsAcdemat.FIN_DOSSIER
    },
    {
      nom: 'liens',
      numeroOrdre: 9,
      affichagePour: [parametrage.originesDossier.ACDEMAT, parametrage.originesDossier.SAD, parametrage.originesDossier.SYNTHURBA],
      typesExclus: ['VA']
    },
    {
      nom: 'affaires-liees',
      numeroOrdre: 10,
      affichagePour: [parametrage.originesDossier.SAD]
    },
    {
      nom: 'pieces',
      numeroOrdre: 11,
      affichagePour: [parametrage.originesDossier.SYNTHURBA]
    },
    {
      nom: 'microfilm',
      numeroOrdre: 12,
      affichagePour: [parametrage.originesDossier.SAD],
      typesExclus: ['VA']
    },
    {
      nom: 'statistiques',
      numeroOrdre: 13,
      affichagePour: [parametrage.originesDossier.ACDEMAT, parametrage.originesDossier.SAD, parametrage.originesDossier.SYNTHURBA],
      typesExclus: ['VA']
    },
    {
      nom: 'relations-projet',
      numeroOrdre: 14,
      affichagePour: [parametrage.originesDossier.ACDEMAT, parametrage.originesDossier.SAD, parametrage.originesDossier.SYNTHURBA],
      typesExclus: ['VA']
    },
    {
      nom: 'synthese-projet',
      numeroOrdre: 15,
      affichagePour: [parametrage.originesDossier.ACDEMAT, parametrage.originesDossier.SAD, parametrage.originesDossier.SYNTHURBA],
      typesExclus: ['VA']
    },
    {
      nom: 'remarques',
      numeroOrdre: 16,
      affichagePour: [parametrage.originesDossier.ACDEMAT, parametrage.originesDossier.SAD, parametrage.originesDossier.SYNTHURBA]
    }
  ]

  public isSectionAAfficher(nomSection: string, controlerStatutMinimum = true) {
    const synoptique = this.store.state.dossier.synoptique
    const section = this.parametrageSections.find((s) => s.nom === nomSection)

    if (!section || !synoptique) {
      return false
    }

    return (
      section.affichagePour.includes(synoptique.origineDossier) &&
      (!section.typesExclus || !section.typesExclus.includes(synoptique.type)) &&
      (!controlerStatutMinimum || !section.statutMinimun || this.isStatutAtteint(section.statutMinimun.nom))
    )
  }

  isStatutAtteint(statut) {
    const etapesCommenceesAvecOrdre = this.store.state.dossier.etapes
      ? this.store.state.dossier.etapes.filter((etape) => etape.dateDebut).map((etape) => StatutsAcdemat[etape.code])
      : []
    const maxEtape: any = etapesCommenceesAvecOrdre.length ? _.maxBy(etapesCommenceesAvecOrdre, 'ordre') : null

    return maxEtape ? StatutDossier.isStatutAtteint(maxEtape.nom, statut) : false
  }
}
